import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "--filled"
}
const _hoisted_2 = {
  key: 1,
  class: "--warning"
}
const _hoisted_3 = { class: "general-dialog__row" }
const _hoisted_4 = { class: "general-dialog__sync" }

import { computed, reactive, watch, ref } from 'vue';
import { SuccessFilled, Select as IconSelect } from '@element-plus/icons-vue';
import { ElDialog, ElIcon, ElTabs, ElTabPane, ElForm, ElFormItem, ElCol, ElRow, ElButton } from 'element-plus';
import cloneDeep from 'lodash.clonedeep';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { Lang, SysReqResponseBackend } from '@/types/manuals';
import LangIcon from '@/components/Form/LangIcon.vue';
import TextEditor from '@/components/Form/TextEditor/Editor.vue';
import { showValidationError } from '@/utils';
import IconSync from '@/components/icons/Sync.vue';
import Tooltip from '@/components/Tooltip.vue';
import services from '@/services/admin';


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogSystemReq',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const store = useStore();

const emit = __emit;

const activeTab = ref(store.getters['Locales/currentSupportedLang']);
const activeField = computed(() => `${activeTab.value}_sysReq`);
const requiredLocales = computed(() => store.getters['Locales/requiredLocales']);
const locales = cloneDeep(store.getters['Locales/locales']);
const formEl = ref();

store.dispatch('Common/getSystemRequirements');
const sysReqArr = computed(() => store.getters['Common/systemRequirements']);
const cloneSysReqArr = computed(() => cloneDeep(sysReqArr.value));

const formData = reactive<Record<string, string>>({});
const syncData = reactive<Record<string, number>>({});

const value = computed(() => formData[activeField.value]);
const showSyncIcon = computed(() => (
  activeField.value in syncData && !syncData[activeField.value]
));

watch(cloneSysReqArr, (value) => {
  const data: any = {};
  value.forEach((data: SysReqResponseBackend) => {
    formData[`${data.locale}_sysReq`] = data.text;
    syncData[`${data.locale}_sysReq`] = data.sync_with_weblate;
  });
  return data;
});

const tabLocales = computed(() => locales.map((loc: any) => {
  loc.isFilled = (() => {
    const isFilled: boolean[] = [];
    const hasText = Boolean(formData[`${loc.value}_sysReq`]);
    isFilled.push(hasText);
    const hasEmptyField = Boolean(isFilled.filter((field) => !field).length);
    return !hasEmptyField;
  })();
  return loc;
}));

const updateData = (value: string) => {
  formData[activeField.value] = value || '';
};

const isValueChanged = (value: string) => formData[activeField.value] !== value;

const handleBlurEditor = (value: string) => {
  if (!isValueChanged(value)) { return; }
  updateData(value);
};

const handleUpdateEditor = () => {
  syncData[activeField.value] = 0;
};

const syncSystemReq = async () => {
  syncData[activeField.value] = 1;
  const inputName = 'system_requirements';
  const data = await services.syncFieldWithWebLate({
    keycloak: 'standard',
    locale: activeTab.value,
    inputName,
  });
  updateData(data[inputName]);
};

const rules = computed(() => {
  const data: any = {};
  requiredLocales.value.forEach((lang: Lang) => {
    data[`${lang}_sysReq`] = [{ required: true, message: '', trigger: 'change' }];
  });
  return data;
});

const undoChanges = () => {
  emit('close');
  store.commit('Common/RESET_SYSTEM_REQ');
};

const checkValid = async () => {
  await formEl.value.validate(async (valid: boolean, fields: any) => {
    if (valid) {
      await saveChanges();
    } else {
      showValidationError({
        fields,
        t,
        supportedLocales: [],
        isScrollToError: false,
        showManualTitle: false,
      });
    }
  });
};

const saveChanges = async () => {
  const list = Object.keys(formData).map((key) => ({
    locale: key.split('_')[0],
    text: formData[key],
    sync_with_weblate: syncData[key],
  }));
  await store.dispatch('Common/setSystemRequirements', list);
  emit('close');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    title: _unref(t)('systemRequirements.standardSysReq'),
    class: "general-dialog",
    closeOnClickModal: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElForm), {
        ref_key: "formEl",
        ref: formEl,
        model: formData,
        rules: rules.value,
        statusIcon: "",
        validateOnRuleChange: false
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTabs), {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
            type: "border-card",
            class: "add-page__tabs add-page__gap"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabLocales.value, (lang) => {
                return (_openBlock(), _createBlock(_unref(ElTabPane), {
                  key: `tab-${lang.value}`,
                  name: lang.value
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)(`languages['${lang.value}']`)) + " ", 1),
                    _createVNode(_unref(ElIcon), { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        (lang.isRequired && lang.isFilled)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                              _createVNode(_unref(IconSelect))
                            ]))
                          : (lang.isRequired)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                            : _createCommentVNode("", true),
                        _createVNode(LangIcon, {
                          lang: lang.value
                        }, null, 8, ["lang"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(ElFormItem), {
                      label: "",
                      prop: `${lang.value}_sysReq`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(TextEditor, {
                            value: value.value,
                            maxlength: 1024,
                            showCounter: "",
                            onBlur: handleBlurEditor,
                            onUpdate: handleUpdateEditor
                          }, null, 8, ["value"]),
                          _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createVNode(Tooltip, {
                              position: "top",
                              message: _unref(t)('tooltipSyncLocal')
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "general-dialog__sync-btn",
                                  onClick: syncSystemReq
                                }, [
                                  _createVNode(IconSync)
                                ])
                              ]),
                              _: 1
                            }, 8, ["message"]), [
                              [_vShow, showSyncIcon.value]
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["prop"])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ElCol), { class: "general-dialog__between" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    class: "ui-btn --big-round",
                    onClick: undoChanges
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    class: "ui-btn --big-round",
                    icon: _unref(SuccessFilled),
                    onClick: checkValid
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('save')), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})